import React, { useEffect, useState } from "react";
import Select from "react-select";

const Dropdown = ({
  label = "",
  options = [],
  required = false,
  needSearch = false,
  disabled = false,
  placeholder = "Select an option",
  name,
  onChange,
  value,
  color = "#ffffff",
  compact = false,
  ...props
}) => {
  const [localValue, setLocalValue] = useState(
    value === undefined || value === null ? null : value
  );

  useEffect(() => {
    setLocalValue(value === undefined || value === null ? null : value);
  }, [value]);

  const handleChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : null;

    if (onChange) {
      onChange(selectedValue, selectedOption);
    }

    setLocalValue(selectedValue); // Update local state with the value (string/ID)
  };

  return (
    <div className="form-control w-full">
      {label && (
        <label
          htmlFor={props.id || props.name}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <Select
        options={options}
        isDisabled={disabled}
        onChange={handleChange}
        value={options.find((option) => option.value === localValue) || null}
        classNamePrefix="react-select"
        placeholder={placeholder}
        noOptionsMessage={() => "No options available"}
        isSearchable={needSearch}
        menuPlacement="auto" // Automatically adjusts menu position
        menuPortalTarget={document.body} // Portal to prevent clipping
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: compact ? "40px" : "44px",
            height: compact ? "40px" : base.height,
            backgroundColor: color,
            borderColor: state.isFocused ? '#2563eb' : disabled ? '#e5e7eb' : '#d1d5db',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(37, 99, 235, 0.1)' : 'none',
            '&:hover': {
              borderColor: disabled ? '#e5e7eb' : '#9ca3af'
            },
            borderRadius: "8px",
            transition: "all 0.2s ease",
          }),
          valueContainer: (base) => ({
            ...base,
            ...(compact ? { paddingTop: 0, paddingBottom: 0, minHeight: "38px" } : {}),
          }),
          indicatorsContainer: (base) => ({
            ...base,
            ...(compact ? { height: "38px" } : {}),
          }),
          placeholder: (base) => ({
            ...base,
            color: color !== '#ffffff' ? '#ffffff' : '#9ca3af',
            fontWeight: color !== '#ffffff' ? '700' : base.fontWeight,
            fontSize: color !== '#ffffff' ? '0.6rem' : base.fontSize,
          }),
          singleValue: (base) => ({
            ...base,
            color: color !== '#ffffff' ? '#ffffff' : '#374151',
            fontWeight: color !== '#ffffff' ? '700' : base.fontWeight,
            fontSize: color !== '#ffffff' ? '0.6rem' : base.fontSize,
          }),
          dropdownIndicator: (base) => ({
            ...base,
            color: color !== '#ffffff' ? '#ffffff' : base.color,
            '&:hover': { color: color !== '#ffffff' ? '#ffffff' : base.color },
          }),
          indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: color !== '#ffffff' ? 'rgba(255,255,255,0.4)' : base.backgroundColor,
          }),
          menu: (base) => ({
            ...base,
            borderRadius: '8px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e5e7eb'
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#2563eb' : state.isFocused ? '#f3f4f6' : 'white',
            color: state.isSelected ? 'white' : '#374151',
            '&:active': {
              backgroundColor: '#1d4ed8'
            }
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    </div>
  );
};

export default Dropdown;
